import { Button, Spinner } from "@shapr3d/frontend-lib";
import type React from "react";

import { useTracker } from "../../hooks/useTracker";
import { ModelViewerWarningPage } from "../../pages/ModelViewerPage/ModelViewerWarningPage";

import style from "./ModelViewerOverlay.module.css";

interface ModelViewerOverlayProps {
  progress?: number;
  error?: boolean;
  onRetry?: () => void;
  showModelSizeWarning?: boolean;
  onDismissWarning?: () => void;
  warningBackground?: string;
}

const ModelViewerOverlay: React.FC<ModelViewerOverlayProps> = ({
  progress = 0,
  error,
  onRetry,
  showModelSizeWarning = false,
  onDismissWarning = () => {},
  warningBackground,
}) => {
  const tracker = useTracker();
  if (error) {
    return (
      <div className={style.modelViewerContainer}>
        <div className={style.errorContainer}>
          <div className={style.errorTitle}>Something went wrong</div>
          <div>Please try loading the design again.</div>
          <Button
            disabled={false}
            onClick={() => {
              tracker.trackButtonClick({ elementId: "webviewer-reload" });
              onRetry?.();
            }}
          >
            Reload
          </Button>
        </div>
      </div>
    );
  }

  if (showModelSizeWarning) {
    return (
      <ModelViewerWarningPage
        onDismissWarning={onDismissWarning}
        backgroundImage={warningBackground}
      />
    );
  }
  return (
    <div className={style.modelViewerContainer}>
      <div>
        <Spinner />
        <div className={style.percentageIndicator}>{progress}%</div>
      </div>
    </div>
  );
};

export default ModelViewerOverlay;
